import React from "react";
import SecurityIcon from "@mui/icons-material/Security";
import SpeedIcon from "@mui/icons-material/Speed";
import GroupsIcon from "@mui/icons-material/Groups";
import LanIcon from "@mui/icons-material/Lan";
import BenefitCard from "./BenefitCard";
import "./benefits.css";

const Benefits = () => {
  const benefits = [
    {
      icon: SecurityIcon,
      title: "More Security",
      copy: "Legal and secure handling of health data according to GDPR.",
    },
    {
      icon: SpeedIcon,
      title: "More Efficiency",
      copy: "Faster, transparent data processes without unnecessary effort.",
    },
    {
      icon: GroupsIcon,
      title: "More Trust",
      copy: "Reliable data that can be used securely and effectively in healthcare.",
    },
    {
      icon: LanIcon,
      title: "Future-Proof",
      copy: "Building a sustainable data governance strategy that grows with regulatory requirements.",
    },
  ];

  return (
    <section className="benefits">
      <div className="benefits__inner">
        <div className="benefits__header">
          <h2 className="benefits__title">Why all of this?</h2>
          <p className="benefits__summary">
            With our digital guide, you can confidently navigate the
            European Health Data Space. <br /> Practical guides and templates help
            teams make data available in a responsible manner.
          </p>
        </div>

        <div className="benefits__grid">
          {benefits.map((benefit, index) => (
            <BenefitCard
              key={index}
              icon={benefit.icon}
              title={benefit.title}
              copy={benefit.copy}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
